module.exports = __webpack_public_path__ + "media/homeNew_web.b1ec04f2.mp4";